/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTagChevronFilled: {
  name: 'tag-chevron-filled';
  data: string;
} = {
  name: 'tag-chevron-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.47 5.043c-.423.1-.817.419-1.014.819-.105.216-.116.277-.116.645v.408l1.269 2.542L4.879 12l-1.27 2.543-1.269 2.542v.408c0 .368.011.429.116.645.154.313.407.559.736.715l.268.127 7.051.011c7.789.011 7.32.026 7.824-.242.134-.071.348-.232.474-.359.219-.218.301-.371 1.604-2.98 1.411-2.825 1.467-2.955 1.467-3.41s-.056-.585-1.467-3.41c-1.303-2.609-1.385-2.762-1.604-2.98a2.384 2.384 0 0 0-.473-.359c-.5-.265-.04-.25-7.736-.246-3.894.002-7.046.019-7.13.038"/></svg>`
};
